<div>
    <div class="flex items-center justify-center dialog-header ">
        {{formAction}} Pipeline

        <div class="absolute right-2">
            <button (click)="onClose()" class="outline-none p-5">
                <i class="pi pi-times"></i>
            </button>
        </div>

    </div>

    <div class="dialog-content">
        <form [formGroup]="pipelineForm" (ngSubmit)="onSubmit()">
            <div class="form-content">
                <!-- Pipeline Name -->
                <div class="form-field">
                    <label for="pipeline_name" class="form-label">
                        Pipeline Name <span class="text-red-500">*</span>
                    </label>
                    <input id="pipeline_name" type="text" pInputText formControlName="pipeline_name"
                        placeholder="Enter pipeline name" class="w-full"
                        [ngClass]="{'ng-invalid ng-dirty': submitted && pipelineForm.get('pipeline_name')?.invalid}" />
                    <small *ngIf="submitted && pipelineForm.get('pipeline_name')?.hasError('required')"
                        class="text-red-500">
                        Pipeline name is required
                    </small>
                    <small *ngIf="submitted && pipelineForm.get('pipeline_name')?.hasError('minlength')"
                        class="text-red-500">
                        Pipeline name must be at least 3 characters
                    </small>
                </div>

                <!-- Set Default -->
                <div class="form-field flex align-items-center gap-2">
                    <p-checkbox formControlName="set_default"
                     [binary]="true" inputId="set_default">
                    </p-checkbox>
                    <label for="set_default" class="form-label mb-0 cursor-pointer">
                        Set as Default Pipeline
                    </label>
                </div>

                <!-- Stages Section -->
                <div class="stages-section">
                    <div class="flex justify-between align-items-center mb-3 w-full">
                        <h4 class="text-lg font-semibold">Pipeline Stages</h4>
                        <button type="button" pButton icon="pi pi-plus" label="Add Stage" class="p-button-sm"
                            (click)="addNewStage()">
                        </button>
                    </div>

                    <div formArrayName="stages" class="stages-list">
                        <div *ngFor="let stage of stages.controls; let i = index" [formGroupName]="i" class="stage-item"
                            [ngClass]="{'stage-default': stage.get('isDefault')?.value}">

                            <div class="stage-content">
                                <div class="stage-number">
                                    {{ i + 1 }}
                                </div>

                                <div class="stage-fields">
                                    <div class="form-field flex-1">
                                        <label [for]="'stage_name_' + i" class="form-label">
                                            Stage Name <span class="text-red-500">*</span>
                                        </label>
                                        <input [id]="'stage_name_' + i" type="text" pInputText
                                            formControlName="stage_name" placeholder="Enter stage name" class="w-full"
                                            [readonly]="stage.get('isDefault')?.value"
                                            [ngClass]="{'ng-invalid ng-dirty': submitted && stage.get('stage_name')?.invalid}" />
                                        <small *ngIf="submitted && stage.get('stage_name')?.invalid"
                                            class="text-red-500">
                                            Stage name is required
                                        </small>
                                    </div>

                                    <div class="form-field score-field">
                                        <label [for]="'score_' + i" class="form-label">
                                            Score (%) <span class="text-red-500">*</span>
                                        </label>
                                        <div class="flex align-items-center gap-2">
                                            <input [id]="'score_' + i" type="number" pInputText formControlName="score"
                                                placeholder="0-100" min="0" max="100" class="score-input"
                                                [readonly]="stage.get('isDefault')?.value"
                                                [ngClass]="{'ng-invalid ng-dirty': submitted && stage.get('score')?.invalid}" />
                                            <span class="score-display">
                                                {{ getScorePercentage(stage.get('score')?.value || 0) }}
                                            </span>
                                        </div>
                                        <small *ngIf="submitted && stage.get('score')?.hasError('required')"
                                            class="text-red-500">
                                            Score is required
                                        </small>
                                        <small
                                            *ngIf="submitted && (stage.get('score')?.hasError('min') || stage.get('score')?.hasError('max'))"
                                            class="text-red-500">
                                            Score must be between 0 and 100
                                        </small>
                                    </div>

                                    <div class="stage-actions">
                                        <button *ngIf="!stage.get('isDefault')?.value" type="button" pButton
                                            icon="pi pi-trash" class="p-button-danger p-button-text p-button-sm"
                                            (click)="removeStage(i)" pTooltip="Remove Stage" tooltipPosition="top">
                                        </button>
                                        <span *ngIf="stage.get('isDefault')?.value" class="default-badge"
                                            pTooltip="Default stage cannot be removed" tooltipPosition="top">
                                            <i class="pi pi-lock text-gray-400"></i>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div *ngIf="stages.length === 0" class="no-stages">
                            <p class="text-gray-500">No stages added. Click "Add Stage" to create a new stage.</p>
                        </div>
                    </div>
                </div>
            </div>

            <div class="dialog-footer">
                <button type="button" pButton label="Cancel" class="p-button-outlined" (click)="onClose()"
                    [disabled]="loading">
                </button>
                <button type="submit" pButton [label]="formAction === 'Edit' ? 'Update' : 'Create'" [loading]="loading"
                    icon="pi pi-check">
                </button>
            </div>
        </form>
    </div>
</div>